import {defineStore, } from 'pinia'
import {computed, } from 'vue'

import {clone, } from '@/js/shared/Utils'

export const useDialogStore = defineStore('dialog-2', {
    state () {
        return {
            dialogData: null,
            dialogIdentifier: '',
            close: false,
        }
    },
    getters: {
        isVisibleComputed: (state) => (identifier) => computed(() => (state.dialogIdentifier === identifier)),
        isVisible: (state) => (identifier) => state.dialogIdentifier === identifier,
    },
    actions: {
        showDialog (item, identifier, cb: Function | null = null) {
            this.dialogData = clone(item)
            this.dialogIdentifier = identifier
            this.close = false
            if (cb) {
                cb(this.dialogData)
            }
        },
        closeDialog () {
            if (this.close === true) {
                this.close = false
            }
            this.close = true
        },
    },
})
